import React from 'react';
import ReactDOM from 'react-dom';

class VideoDOM extends React.Component{

	constructor(props){
		super(props);
		
		this.state = {
			src : ""
		}
	}

	componentDidMount(){

		let srcBlob = (window.webkitURL ? webkitURL : URL).createObjectURL(this.props.src)
		
		this.setState({
			src : srcBlob
		});
		
		if(this.props.muted == "true"){
			this.refs.video.setAttribute('muted',"muted");
		}

		this.timeupdate = ()=>this.props.timeupdate(this.refs.video);

		if('ended' in this.props){
			this.ended = ()=>this.props.ended();
			this.refs.video.addEventListener('ended',this.ended,false);
		}
		this.refs.video.addEventListener('timeupdate',this.timeupdate,false);

		if(this.props.autoPlay === "true"){
			//console.log('autoPlay');

			this.refs.video.play();
		}

	}

	componentWillUnmount(){
		this.refs.video.removeEventListener('timeupdate',this.timeupdate);

		if('ended' in this.props){
			this.refs.video.removeEventListener('ended',this.ended);
		}
		
	}

	getDuration(){
		return this.refs.video.duration;
	}

	playVideo(){
		var videoPromise = this.refs.video.play();
		return videoPromise;
	}

	pauseVideo(){
		this.refs.video.pause();
	}
	getCurrentTime(){
		return this.refs.video.currentTime;
	}

	changeVolume(volume){
		this.refs.video.volume = volume;
	}

	seekTo(timecode){

		this.refs.video.currentTime = timecode ;

	}


	render(){
			
		return(<div className={ "videoDOM " + this.props.name}>
			<video className="" poster="" playsInline ref="video">
					<source src={this.state.src} type="video/mp4" />
				</video>
		</div>);
	}
}

export default VideoDOM;


// WEBPACK FOOTER //
// ./src/scripts/videoDOM.js